import home1 from "../../assets/img/IMG-20251110-WA0029.jpg";
import { Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
const ourService = [
  { id: 1, name: "Landscape Design", url: "landscape-design" },
  { id: 2, name: "Hardscape", url: "hardscape" },
  { id: 3, name: "Landscape Lighting", url: "landscape-lighting" },
  { id: 4, name: "Softscape", url: "softscape" },
  { id: 5, name: "Plantation", url: "plantation" },
  { id: 6, name: "Replanting", url: "replanting" },
  {
    id: 7,
    name: "Lawn Development and Maintenance",
    url: "lawn-development-and-maintenance",
  },
  {
    id: 8,
    name: "Horticultural Maintenance",
    url: "horticultural-maintenance",
  },
  {
    id: 9,
    name: "Vertical & Terrace Garden",
    url: "vertical-and-terrace-garden",
  },
  { id: 10, name: "Irrigation System", url: "irrigation-system" },
];
function IrrigationSystem() {
  return (
    <>
      <section className="serviceList sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12">
              <div className="aboutImg">
                <img src={home1} alt="About" className="img-fluid" />
              </div>
              <div className="blogCategory mt-4">
                <ul>
                  {ourService.map((item) => {
                    return (
                      <li key={item.id}>
                        <Link to={`${item.url}`}>
                          <FiChevronRight />
                          {item.name}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
            <div className="col-lg-8 col-md-12">
              <div className="aboutWooden">
                <div className="fisherman-content">
                  <h3>💧 Irrigation System</h3>
                  <p>
                    When you set up a proper irrigation system in your garden,
                    it transforms watering from a chore into something almost
                    automatic. Rather than dragging a hose around and guessing
                    how much water each plant needs, the system delivers the
                    water directly to the roots or the exact zone that needs it.
                    This means the soil stays more evenly moist, plants don’t
                    suffer from overwatering or underwatering, and you end up
                    having to spend less time worrying about watering
                    altogether.
                  </p>
                  <p>
                    One of the biggest upsides is water efficiency. Modern
                    irrigation systems—especially drip-irrigation types—waste
                    far less water because they avoid spraying water into the
                    air or onto hard surfaces. In practical terms, you’ll see
                    fewer puddles, less runoff, and more water actually going
                    into the root zone of your plants. That not only saves water
                    (and money) but also supports healthier plant growth.
                    DripWorks
                  </p>
                  <p>
                    It also helps your plants become stronger and healthier.
                    Because the water is targeted, the roots develop better,
                    there’s less chance of fungal diseases (which thrive when
                    leaves or soil are overly wet), and the soil stays in better
                    shape—less erosion, fewer nutrients washing away. A
                    well-designed irrigation system treats your garden more like
                    a well-tended ecosystem rather than just something you water
                    when you remember.{" "}
                  </p>
                </div>
                  <div className="fisherman-content">
                <h5>🔩 Key Components of a Reliable Irrigation System</h5>
                <ul>
                  <li>🚰 Water source (tank, tap, borewell, rainwater)</li>
                  <li>📍 Pipes and tubing for water delivery</li>
                  <li>🔄 Valves and control systems</li>
                  <li>⏱️ Timers and moisture sensors (for automation)</li>
                  <li>🔧 Filters, emitters, and regulators for efficiency</li>
                </ul>
              </div>
                <div className="fisherman-content">
                  <h5>💧 Ready to Save Water &amp; Grow Greener?</h5>
                  <p>
                    Whether it's a home garden, commercial landscape, or rooftop
                    green space — we design efficient irrigation systems
                    tailored to your needs and climate.
                  </p>
                  <a
                    className="commonButton mt-3"
                    href="mailto:info@example.com"
                  >
                    📧 Contact Us Today
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-12 mt-5">
              {/* Installation & Maintenance */}
              <div className="fisherman-content d-none">
                <h5>🔧 Installation &amp; Maintenance</h5>
                <ul>
                  <li>🗺️ Site analysis and customized layout</li>
                  <li>🔨 Professional system setup and testing</li>
                  <li>🛠️ Regular inspection and cleaning</li>
                  <li>🔁 Seasonal adjustments (based on weather)</li>
                  <li>📦 Upgrade to smart irrigation solutions</li>
                </ul>
              </div>
              {/* Our Services */}
              <div className="fisherman-content d-none">
                <h5>🌾 Our Irrigation Services Include:</h5>
                <ul>
                  <li>Design and installation of custom irrigation systems</li>
                  <li>Drip and sprinkler system setup</li>
                  <li>Smart automation with timers and sensors</li>
                  <li>System troubleshooting and repair</li>
                  <li>Water harvesting and recycling solutions</li>
                  <li>Annual maintenance plans</li>
                </ul>
              </div>
              {/* Call to Action */}
              {/* Lawn Development */}
              <div className="fisherman-content d-none">
                <h5>🌱 Why a Good Irrigation System Matters</h5>
                <ul>
                  <li>
                    <strong>Water Efficiency:</strong> Reduces water waste
                    through precise distribution
                  </li>
                  <li>
                    <strong>Healthier Plants:</strong> Consistent moisture
                    levels support strong growth
                  </li>
                  <li>
                    <strong>Time Saving:</strong> Automates the watering
                    process, saving effort
                  </li>
                  <li>
                    <strong>Reduces Manual Errors:</strong> Avoids overwatering
                    and underwatering
                  </li>
                  <li>
                    <strong>Promotes Sustainability:</strong> Helps conserve
                    natural resources
                  </li>
                </ul>
              </div>
              <div className="fisherman-content d-none">
                <h5>🧪 Types of Irrigation Systems</h5>
                <ul>
                  <li>
                    💦 <strong>Drip Irrigation:</strong> Delivers water directly
                    to plant roots; ideal for precision watering
                  </li>
                  <li>
                    🌧️ <strong>Sprinkler Systems:</strong> Mimics rainfall;
                    great for lawns and large gardens
                  </li>
                  <li>
                    📏 <strong>Soaker Hoses:</strong> Releases water slowly
                    along the length of the hose
                  </li>
                  <li>
                    🕳️ <strong>Manual Irrigation:</strong> Hand watering using
                    hoses or watering cans
                  </li>
                  <li>
                    ⏰ <strong>Automated Systems:</strong> Timers and sensors
                    for scheduled irrigation
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default IrrigationSystem;
